

export default function Sample3() {
    return(
        <>
            Hello World 3
        </>
    );
}